import DateFormat from '../utils/DateFormat';

export function intToDate(date) {
    return new Date(
        parseInt(date.toString()
            .substring(0, 4), 10),
        parseInt(date.toString()
            .substring(4, 6) - 1, 10),
        parseInt(date.toString()
            .substring(6, 8), 10),
    );
}

function getTodayDate() {
    return intToDate(DateFormat.dashedToPlain(new Date().toISOString()
        .substr(0, 10)));
}

export function isDateObject(date) {
    return date instanceof Date;
}

export function isInFuture(date = null) {
    let clonedDate = date;
    if (clonedDate == null) return false;
    // console.log(date, 'EZ A DÁTUM')
    clonedDate = intToDate(clonedDate);
    // console.log('a validator most fut ')
    return isDateObject(clonedDate) && clonedDate >= getTodayDate();
}

export function isInPast(date = null) {
    let clonedDate = date;
    if (clonedDate == null) return false;
    clonedDate = intToDate(clonedDate);
    // console.log('A validator most fut')
    return isDateObject(clonedDate) && clonedDate <= getTodayDate();
}

export function isDate(date, msg) {
    /// /console.log(date, msg)
    if (typeof date === 'undefined' || date == null) return false;
    const datePattern = /^([12]\d{3})([012]\d)([0123]\d)/;
    return datePattern.test(date.toString()) || msg;
}

export function dateBefore(date, before) {
    return isDateObject(date) && isDateObject(before) && date < before;
}

export function dateAfter(date, after) {
    return isDate(date) && isDateObject(after) && date > after;
}

export function isValidEmail(email) {
    /* eslint-disable-next-line max-len */
    const emailPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    return emailPattern.test(String(email)
        .toLowerCase());
}

export function isValidMegerositoKod(kod) {
    const kodPattern = /[0-9]{8}/g;
    return kodPattern.test(String(kod));
}

export function isValidPhoneNumber(number) {
    const phoneNumberPattern = /(1|20|30|31|70|50)[0-9]{7}/g;
    return phoneNumberPattern.test(String(number));
}

export function isValidMobilNumber(number) {
    if (String(number) === '') {
        return true;
    }

    const numberPattern = /\d+/g;

    const clonedNumber = number.match(numberPattern)
        .join('');

    if (Number(clonedNumber.length) > 9) {
        return false;
    }

    const phoneNumberPattern = /(20|30|31|70|50)[0-9]{7}/g;
    return phoneNumberPattern.test(String(clonedNumber));
}

export function lessThan(val, number) {
    return val < number;
}

export function moreThan(val, number) {
    return val > number;
}

export function lessThanEqual(val, number) {
    return val <= number;
}

export function carPriceBetween(val, nfrom, nto) {
    // csak számokat hagyni
    let num = String(val);
    num = num.replace(/\D/g, '');

    if (parseInt(num, 10) < nfrom || parseInt(num, 10) > nto) {
        return false;
    }

    return true;
}

export function carPriceNetGross(net, gross) {
    let netstr = String(net);
    netstr = netstr.replace(/\D/g, '');
    let grossstr = String(gross);
    grossstr = grossstr.replace(/\D/g, '');

    if (parseInt(netstr, 10) > parseInt(grossstr, 10)) {
        return false;
    }

    return true;
}

export function olderThanHalfYear(dateInt) {
    let dateString = dateInt.toString();
    dateString = [dateString.substring(0, 4), dateString.substring(4, 6), dateString.substring(6, 8)].join('/');
    const HALF_YEAR = (365 * 24 * 1000 * 60 * 60) / 2;
    const halfYearAgo = Date.now() - HALF_YEAR;
    return new Date(dateString) < halfYearAgo;
}

export function getAge(dateInt) {
    let clonedDateInt = dateInt;
    if (clonedDateInt === null) {
        clonedDateInt = 0;
    }
    let dateString = clonedDateInt.toString();
    dateString = [dateString.substring(0, 4), dateString.substring(4, 6), dateString.substring(6, 8)].join('/');
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1;
    }
    return age;
}

export function youngerThan(val, number) {
    const age = getAge(val);
    return age < number;
}

export function olderThan(val, number) {
    const age = getAge(val);
    return age > number;
}

export function equal(val, number) {
    return val === number;
}

export function greaterThan(val, number) {
    return val > number;
}

export function greaterThanEqual(val, number) {
    return val >= number;
}

export function isBankszamla(szam = '') {
    let clonedSzam = szam;
    if (clonedSzam == null) {
        return false;
    }

    clonedSzam = clonedSzam.toString()
        .split('-')
        .join('');

    const digits = [9, 7, 3, 1, 9, 7, 3, 1];
    const pieces = [];
    const pattern1 = /^[0-9]{16}$/;
    const pattern2 = /^[0-9]{24}$/;
    const sameCharPattern = /^(.)\1+$/;
    let masodikEllOsszegIndex = 0;

    if (!pattern1.test(clonedSzam) && !pattern2.test(clonedSzam)) {
        return false;
    }

    if (sameCharPattern.test(clonedSzam)) return false;

    pieces.push(clonedSzam.substring(0, 8));
    if (Number(clonedSzam.length) === 16) {
        pieces.push(clonedSzam.substring(8, 16));
        masodikEllOsszegIndex = 15;
    } else if (Number(clonedSzam.length) === 24) {
        pieces.push(clonedSzam.substring(8, 24));
        masodikEllOsszegIndex = 23;
    }

    // 1-8 ellenőrzés
    let checksumIndex = -1;
    let sum = 0;
    for (let jj = 0; jj < pieces[0].length - 1; jj += 1) {
        checksumIndex += 1;
        sum += (parseInt(pieces[0][jj], 10) * parseInt(digits[checksumIndex], 10));
    }

    let checksum = String(sum);
    let utolsoHelyiertek = parseInt(checksum.charAt(checksum.length - 1), 10);
    let ellenorzoOsszeg = ((10 - utolsoHelyiertek) === 10) ? 0 : (10 - utolsoHelyiertek);
    if (ellenorzoOsszeg !== parseInt(clonedSzam.charAt(7), 10)) {
        return false;
    }

    // 2. rész ellenőrzés
    checksumIndex = -1;
    sum = 0;
    for (let jj = 0; jj < pieces[1].length - 1; jj += 1) {
        checksumIndex += 1;
        if (checksumIndex > 7) {
            checksumIndex = 0;
        }
        sum += (parseInt(pieces[1][jj], 10) * parseInt(digits[checksumIndex], 10));
    }

    checksum = String(sum);
    utolsoHelyiertek = parseInt(checksum.charAt(checksum.length - 1), 10);
    ellenorzoOsszeg = ((10 - utolsoHelyiertek) === 10) ? 0 : (10 - utolsoHelyiertek);
    if (ellenorzoOsszeg !== parseInt(clonedSzam.charAt(masodikEllOsszegIndex), 10)) {
        return false;
    }

    return true;
}

// ez rossz
export function isBankszamlaRegi(szam = '') {
    let clonedSzam = szam;
    if (clonedSzam == null) {
        return false;
    }

    clonedSzam = clonedSzam.toString()
        .split('-')
        .join('');

    const digits = [9, 7, 3, 1, 9, 7, 3, 1];
    const pieces = [];

    if (clonedSzam.length > 16) {
        pieces.push(clonedSzam.substring(16, 24));
    }
    pieces.push(clonedSzam.substring(0, 8));
    pieces.push(clonedSzam.substring(8, 16));

    if (clonedSzam.length < 16 || (clonedSzam.length > 16 && clonedSzam.length < 24)) {
        return false;
    }

    for (let ii = 0; ii < pieces.length; ii += 1) {
        let sum = 0;
        for (let jj = 0; jj < pieces[ii].length; jj += 1) {
            // console.log(pieces[ii][jj], digits[jj])
            sum += pieces[ii][jj] * digits[jj];
        }
        if (sum % 10 !== 0) {
            return false;
        }
    }
    return true;
}

export function isValidKotvenyszam(szam) {
    if (szam === '') {
        return 'A kötvényszám kitöltése kötelező.';
    }

    const pattern = /^[A-Ba-b0-9]{1,30}$/;
    return pattern.test(szam) || 'A kötvényszám nem érvényes.';
}

export function isValidCsekksorszam(szam) {
    if (String(szam) === '') {
        return 'A csekksorszám kitöltése kötelező.';
    }

    const pattern = /^[0-9]{8,10}$/;
    return pattern.test(szam) || 'A csekksorszám nem érvényes. (1XXXXXXXXX)';
}

export function isValidSuperShop(szam) {
    if (String(szam) === '') {
        return true;
    }

    const pattern = /^[0-9]{16}$/;
    return pattern.test(szam) || 'A SuperShop kártyaszám nem érvényes.';
}

export function isUnionPromociosKod(kod) {
    const pattern = /^[A-Ba-b0-9]{1,30}$/;
    if (String(kod) === '') {
        return true;
    }

    return pattern.test(kod) || 'A kód nem érvényes.';
}

export function isUnionSpecEngedmeny(szam) {
    const pattern = /^[0-9]{1,3}$/;
    if (String(szam) === '') {
        return true;
    }

    if (Number(szam) < 1 || Number(szam) > 100) {
        return 'A speciális engedmény értéke nem megfelelő. (1-100)%';
    }

    return pattern.test(szam) || 'A speciális engedmény értéke nem megfelelő. (1-100)%';
}

export function isValidFunTartam(szam) {
    const pattern = /^[0-9]{1,3}$/;

    if (Number(szam) < 10 || Number(szam) > 1000) {
        return 'Tartam nem érvényes. (Minimum 10 napra köthető)';
    }

    return pattern.test(szam) || 'Tartam nem érvényes. (Minimum 10 napra köthető)';
}

export function isValidUnionGyerek(szam) {
    if (Number(szam) !== 1 && Number(szam) !== 2 && Number(szam) !== 3) {
        return 'Union gyerek csomag érték nem érvényes.';
    }

    return true;
}

export function isValidRisk1560(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) < 2000000 || Number(szam) > 20000000) {
        return 'Baleseti eredetű halál biztosítás összege nem érvényes. (2.000.000-20.000.000)';
    }

    if (Number(szam) % 1000000 !== 0) {
        return '(Baleseti eredetű halál) A biztosítási összeget, a minimum biztosítási összegtől kiindulva 1 millió'
            + ' forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű halál biztosítás összege nem érvényes. (2.000.000-20.000.000)';
}

export function isValidRisk1561(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) < 2000000 || Number(szam) > 20000000) {
        return 'Baleseti eredetű maradandó egészségkárosodás biztosítás összege nem érvényes. (2.000.000-20.000.000)';
    }

    if (Number(szam) % 1000000 !== 0) {
        return '(Baleseti eredetű maradandó egészségkárosodás) A biztosítási összeget, a minimum biztosítási'
            + ' összegtől kiindulva 1 millió forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű maradandó egészségkárosodás biztosítás összege nem érvényes.'
        + ' (2.000.000-20.000.000)';
}

export function isValidRisk1562(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) < 2000000 || Number(szam) > 20000000) {
        return 'Baleseti eredetű kómás állapot biztosítás összege nem érvényes. (2.000.000-20.000.000)';
    }

    if (Number(szam) % 1000000 !== 0) {
        return '(Baleseti eredetű kómás állapot) A biztosítási összeget, a minimum biztosítási összegtől kiindulva '
            + '1 millió forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű kómás állapot biztosítás összege nem érvényes.'
        + ' (2.000.000-20.000.000)';
}

export function isValidRisk1565(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if (Number(szam) < 200000 || Number(szam) > 2000000) {
        return 'Baleseti eredetű műtét biztosítás összege nem érvényes. (200.000-2.000.000)';
    }

    if (Number(szam) % 100000 !== 0) {
        return '(Baleseti eredetű műtét) A biztosítási összeget, a minimum biztosítási összegtől kiindulva'
        + ' 100000 forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű műtét biztosítás összege nem érvényes. (200.000-2.000.000)';
}

export function isValidRisk1567(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if ((Number(szam) < 50000 || Number(szam) > 200000) || (Number(szam) % 50000 !== 0)) {
        return 'Baleseti eredetű, endoszkópos technikával végzett térd műtét biztosítás összege nem érvényes.'
        + ' (50.000, 100.000, 150.000, 200.000)';
    }

    return pattern.test(szam) || 'Baleseti eredetű, endoszkópos technikával végzett térd műtét biztosítás összege'
        + ' nem érvényes. (50.000, 100.000, 150.000, 200.000)';
}

export function isValidRisk1566(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if ((Number(szam) < 100000 || Number(szam) > 400000) || (Number(szam) % 100000 !== 0)) {
        return 'Baleseti eredetű, endoszkópos technikával végzett egyéb műtét biztosítás összege nem érvényes.'
            + ' (100.000, 200.000, 300.000, 400.000)';
    }

    return pattern.test(szam) || 'Baleseti eredetű, endoszkópos technikával végzett egyéb műtét biztosítás összege'
        + ' nem érvényes. (100.000, 200.000, 300.000, 400.000)';
}

export function isValidRisk1568(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if ((Number(szam) < 1000000 || Number(szam) > 4000000) || (Number(szam) % 1000000 !== 0)) {
        return 'Baleseti eredetű helyreállító plasztikai műtét biztosítás összege nem érvényes.'
            + ' (1.000.000, 2.000.000, 3.000.000, 4.000.000)';
    }

    return pattern.test(szam) || 'Baleseti eredetű helyreállító plasztikai műtét biztosítás összege nem érvényes.'
        + ' (1.000.000, 2.000.000, 3.000.000, 4.000.000)';
}

export function isValidRisk1563(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if (Number(szam) < 2000 || Number(szam) > 20000) {
        return 'Baleseti eredetű kórházi napi térítés biztosítás összege nem érvényes. (2.000-20.000) / nap';
    }

    if (Number(szam) % 1000 !== 0) {
        return '(Baleseti eredetű kórházi napi térítés) A biztosítási összeget, a minimum biztosítási összegtől'
            + ' kiindulva 1000 forinttal lehet emelni. ';
    }

    return pattern.test(szam) || 'Baleseti eredetű kórházi napi térítés biztosítás összege nem érvényes.'
        + ' (2.000-20.000) / nap';
}

export function isValidRisk1570(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if (Number(szam) < 40000 || Number(szam) > 400000) {
        return 'Baleseti eredetű, 60 napot meghaladó kórházi ellátás, egyösszegű térítés biztosítási összege'
            + ' nem érvényes. (40.000-400.000)';
    }

    if (Number(szam) % 20000 !== 0) {
        return '(Baleseti eredetű, 60 napot meghaladó kórházi ellátás) A biztosítási összeget, a minimum biztosítási'
            + ' összegtől kiindulva 20000 forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű, 60 napot meghaladó kórházi ellátás, egyösszegű térítés'
        + ' biztosítási összege nem érvényes. (40.000-400.000)';
}

export function isValidRisk1569(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if (Number(szam) < 40000 || Number(szam) > 400000) {
        return 'Baleseti eredetű csonttörés biztosítási összege nem érvényes. (40.000-400.000)';
    }

    if (Number(szam) % 20000 !== 0) {
        return '(Baleseti eredetű csonttörés) A biztosítási összeget, a minimum biztosítási összegtől kiindulva'
        + ' 20000 forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű csonttörés biztosítási összege nem érvényes. (40.000-400.000)';
}

export function isValidRisk1571(szam) {
    const pattern = /^[0-9]{4,9}$/;

    if (Number(szam) === 0) {
        return true;
    }

    if (Number(szam) < 200000 || Number(szam) > 2000000) {
        return 'Baleseti eredetű égés biztosítási összege nem érvényes. (200.000-2.000.000)';
    }

    if (Number(szam) % 100000 !== 0) {
        return '(Baleseti eredetű égés) A biztosítási összeget, a minimum biztosítási összegtől kiindulva'
            + ' 100000 forinttal lehet emelni.';
    }

    return pattern.test(szam) || 'Baleseti eredetű égés biztosítási összege nem érvényes. (200.000-2.000.000)';
}

export function isIrszam(szam) {
    return parseInt(szam, 10) < 10000 && parseInt(szam, 10) > 999;
}

export function isTajSzam(szam) {
    const tajSzamPattern = /\d{9}/;
    return tajSzamPattern.test(String(szam));
}

export function isFutureBy15Days(date) {
    let clonedDate = date;
    if (clonedDate == null) {
        clonedDate = 0;
    }
    let dateString = clonedDate.toString();
    dateString = [dateString.substring(0, 4), dateString.substring(4, 6), dateString.substring(6, 8)].join('/');
    const date1 = new Date();
    const date2 = new Date(dateString);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays >= 15;
}

export function firstOfMonth(date) {
    /** 2018.12.15.-ig engedjük korábban is  */
    let clonedDate = date;
    if (clonedDate == null) {
        clonedDate = 0;
    }

    let dateString = clonedDate.toString();
    dateString = [dateString.substring(0, 4), dateString.substring(4, 6), dateString.substring(6, 8)].join('/');
    clonedDate = new Date(dateString);

    const mostHo = new Date().getUTCMonth();
    const kockKezdHo = clonedDate.getUTCMonth();
    const diffLessThanTwo = Math.abs(mostHo - kockKezdHo) < 2;

    return clonedDate.getDate() === 1 && diffLessThanTwo;
}

export function lengthMay(value, num) {
    return value === 0 || value === '' || value == null || typeof value === 'undefined' || value.length === num;
}

export function isRendszam(value) {
    /* eslint-disable-next-line max-len */
    const rendszamPattern = /^(([A-Z]{3}[0-9]{3})|(M[0-9]{6})|((CD|DT|CK)[0-9]{6})|([A-Z]{1}[0-9]{5})|([A-Z]{2}[0-9]{4})|([A-Z]{4}[0-9]{2})|([A-Z]{5}[0-9]{1}))$/;
    return rendszamPattern.test(value);
}

export function required(value, message) {
    return (typeof value !== 'undefined' && value !== null && value !== '') || message;
}

export function cegformaRequired(value, isceg, message) {
    return ((!isceg) || (typeof value !== 'undefined' && value !== null && value !== '')) || message;
}

/*
 Az adószám 11 számjegyből áll. A nyolcadik számjegye az ellenőrző szám. Az ellenőrző
 szám képzése az alábbiak szerint történik:
 Az első hét számjegyet helyiértékük csökkenő sorrendjében szorozzuk a 9, 7, 3, 1, 9, 7, 3
 számjegyekkel, a szorzatokat összeadjuk, és az eredmény 1-es helyiértékén lévő számot
 kivonjuk 10-ből. A különbség az ellenőrző szám.
 */
export function isAdoszam(value, message) {
    const szam = String(value);
    const aszPattern = /^\d{11}$/;
    if (!aszPattern.test(szam)) {
        return (false === true) || message;
    }

    let sum = 0;
    sum += (parseInt(szam.charAt(0), 10) * 9);
    sum += (parseInt(szam.charAt(1), 10) * 7);
    sum += (parseInt(szam.charAt(2), 10) * 3);
    sum += (parseInt(szam.charAt(3), 10) * 1);
    sum += (parseInt(szam.charAt(4), 10) * 9);
    sum += (parseInt(szam.charAt(5), 10) * 7);
    sum += (parseInt(szam.charAt(6), 10) * 3);
    const checksum = String(sum);
    const utolsoHelyiertek = parseInt(checksum.charAt(checksum.length - 1), 10);
    if ((10 - utolsoHelyiertek) !== parseInt(szam.charAt(7), 10)) {
        return (false === true) || message;
    }

    const AFAKOD = ['1', '2', '3', '4', '5'];
    const SZEKHELYKOD = ['02', '22', '03', '23', '04', '24', '05', '25', '06', '26', '07', '27', '08', '28', '09', '29',
        '10', '30', '11', '31', '12', '32', '13', '33', '14', '34', '15', '35', '16', '36', '17', '37',
        '18', '38', '19', '39', '20', '40', '41', '42', '43', '44', '51'];
    const adoszamReszek = [szam.charAt(8), `${szam.charAt(9)}${szam.charAt(10)}`];
    if (!AFAKOD.includes(adoszamReszek[0])) {
        return (false === true) || message;
    }

    if (!SZEKHELYKOD.includes(adoszamReszek[1])) {
        return (false === true) || message;
    }

    return true;
}

export function isAdoazonositoJel(value, message) {
    const szam = String(value);
    const ajPattern = /^8\d{9}$/;
    if (!ajPattern.test(szam)) {
        return (false === true) || message;
    }

    let sum = 0;
    for (let i = 0; i < 9; i += 1) {
        sum += (parseInt(szam.charAt(i), 10) * (i + 1));
    }
    sum %= 11;
    if (parseInt(sum, 10) !== parseInt(szam.charAt(9), 10)) {
        return (false === true) || message;
    }

    return true;
}

// nagyobbnak kell lenni mint a mai nap
// max 270 nap lehet
export function isValidBalesetKockkezdetDatum(vle) {
    const value = String(vle);
    if (!value) {
        return (false === true) || 'Nem adott meg értéket.';
    }

    const datePattern = /^[0-9]{8}$/;
    const tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    const tomorrowString = `${tomorrow.getFullYear()}/`
        + `${String(tomorrow.getMonth() + 1)
            .padStart(2, '0')}/${String(tomorrow.getDate())
            .padStart(2, '0')}`;
    const dateFrom = new Date(tomorrowString);

    // console.log(typeof value);
    let output = [value.slice(0, 4), '/', value.slice(4)].join('');
    output = [output.slice(0, 7), '/', output.slice(7)].join('');
    const dateCheck = new Date(output);

    const fromD = Date.parse(dateFrom);
    const check = Date.parse(dateCheck);

    if (!datePattern.test(value)) {
        return 'Érvénytelen kockázatviselési dátum formátum.';
    }
    if (!(check >= fromD)) {
        return 'A kockázatviselési dátumának nagyobbnak kell lennie mint a mai nap.';
    }

    return true;
}

export function isNyilatkozatElfogadva(value, message) {
    /// /console.log(value);
    return (Boolean(value) === true) || message;
}

/*
Csak nagyobb lehet mint a mai nap
 */
export function isValidOkmanyErvenyesseg(vle) {
    const value = String(vle);
    if (!value) {
        return (false === true) || 'Érvénytelen dátum.';
    }

    const datePattern = /^[0-9]{8}$/;
    const now = new Date();
    const nowString = `${now.getFullYear()}/${String(now.getMonth() + 1)
        .padStart(2, '0')}`
        + `/${String(now.getDate())
            .padStart(2, '0')}`;
    const dateTo = new Date(nowString);

    let output = [value.slice(0, 4), '/', value.slice(4)].join('');
    output = [output.slice(0, 7), '/', output.slice(7)].join('');
    const dateCheck = new Date(output);

    const to = Date.parse(dateTo);
    const check = Date.parse(dateCheck);

    if (!(datePattern.test(value))) {
        return (false === true) || 'Érvénytelen formátum.';
    }

    return (check > to) || 'Az okmány érvényessége lejárt.';
}

export function isGeneralTextfieldCharacters(value) {
    const textPattern = /^[A-Z0-9a-z._() \-'",:;&ß$öüóőúéáűíÖÜÓŐÚÉÁŰÍ]{1,70}$/;
    return textPattern.test(value) || 'Nem megengedett karakter. Max 70 karakter.';
}

/*
Nncs ellenőrzőöszegük csak formátum ell.
1: személyi
2: jogsi
3: útlevél
 */
export function isValidOkmany(value, okm) {
    if (Number(okm) === 1) {
        const pattern = /^[0-9]{6}[A-Za-z]{2}$/;
        return pattern.test(value) || 'Nem megfelelő a személyi igazolvány számának a formátuma. [123456AB]';
    }
    if (Number(okm) === 2) {
        const pattern = /^[A-Za-z]{2}[0-9]{6}$/;
        return pattern.test(value) || 'Nem megfelelő a vezetői engedély számának a formátuma. [AB123456]';
    }
    if (Number(okm) === 3) {
        const pattern = /^[A-Za-z]{2}[0-9]{7}$/;
        return pattern.test(value) || 'Nem megfelelő az útlevél számának a formátuma. [AB1234567]';
    }

    return (false === true) || 'Érvénytelen okmánytípus.';
}

export function isValidLakcimkartya(value) {
    const pattern = /^[0-9]{6}[A-Za-z]{2}$/;
    return pattern.test(value) || 'Nem megfelelő a lakcímkártya számának a formátuma. [123456AB]';
}

export function isCegjegyzekszam(value) {
    const pattern = /(\d{2})(\d{2})(\d{6})/;
    return pattern.test(value) || 'Nem megfelelő cégjegyzékszám!';
}

// ez azért kell ha kiXeli a user a mezőt és az érték objectre vált kiszűrük
export function isVariableTypeAnObject(value, message) {
    if ((Object.prototype.toString.call(value) === '[object Object]')) {
        return message;
    }

    return true;
}

export function isVariableTypeAnArray(value, message) {
    if ((Object.prototype.toString.call(value) === '[object Array]') || Array.isArray(value)) {
        return message;
    }

    return true;
}

export function isKshSzam(value) {
    const pattern = /^[0-9]{17}$/;
    return pattern.test(value);
}

export function gapTulajdonosiViszonyokv1(tulajdoniViszony, tulajtipus) {
    /* let pattern = /^[0-9]{17}$/; */

    if (Number(tulajdoniViszony) === 1 && Number(tulajtipus) !== 1) {
        /* return 'A tulajdonosi viszony nem lehet saját tulajdon.'; */
    }

    if (Number(tulajdoniViszony) !== 1 && Number(tulajtipus) === 1) {
        return 'A tulajdonosi viszony saját tulajdon kell legyen.';
    }

    return true;
}

export function gapTulajdonosiViszonyokv2(tulajdoniViszony, tulajtipus) {
    /* let pattern = /^[0-9]{17}$/; */

    if (Number(tulajdoniViszony) === 1 && Number(tulajtipus) !== 1) {
        return 'A tulajdonos típusa szerződő kell legyen.';
    }

    if (Number(tulajdoniViszony) !== 1 && Number(tulajtipus) === 1) {
        /* return 'A tulajdonos típusa nem lehet szerződő.'; */
    }

    return true;
}

export const rules = {
    // TODO:: a hiba üzeneteket fel lehet vinne a metódusokba ha esetleg több / pontosabb hibaüzenetet akarunk
    //  visszaadni
    required: (value, msg) => required(value, msg),
    cegformaRequired: (value, isceg, msg) => cegformaRequired(value, isceg, msg),
    isInFutere: (value) => isInFuture(value) || 'A mező értéke nem lehet korábban mint a mai nap!',
    validEmail: (value) => isValidEmail(value) || 'Az email cím formátuma nem megfelelő!',
    validMegerositoKod: (value) => isValidMegerositoKod(value) || 'A megerősítő kód formátuma nem megfelelő!',
    validPhoneNumber: (value) => isValidPhoneNumber(value) || 'A telefonszám formátuma nem megfelelő',
    isValidMobilNumber: (value) => isValidMobilNumber(value) || 'A mobiltelefonszám formátuma nem megfelelő',
    isInPast: (value) => isInPast(value) || 'A mező értéke nem lehet későbbi mint a mai nap!',
    isBankszamla: (value) => isBankszamla(value) || 'A bankszámlaszám formátuma nem megfelelő',
    isIrszam: (value) => isIrszam(value) || 'Az irányítószám formátuma nem megfelelő',
    lessThan: (value, num) => lessThan(value, num) || `A megadott értéknek kisebbnek kell lennie mint ${num}`,
    moreThan: (value, num) => moreThan(value, num) || `A megadott értéknek nagyobbnak kell lennie mint ${num}`,
    carPriceBetween: (value, nfrom, nto) => carPriceBetween(value, nfrom, nto)
        || `A megadott vételárnak a két érték közé kell esnie. (${nfrom}-${nto})`,
    carPriceNetGross: (net, gross) => carPriceNetGross(net, gross)
        || 'A nettó vételár nem lehet nagyobb a bruttó vételárnál.',
    isTajSzam: (value) => isTajSzam(value) || 'A TAJ szám formátuma nem megfejelő',
    olderThanHalfYear: (value) => olderThanHalfYear(value) || 'Csak fél évnél idősebb gyermekre köthető!',
    olderThan: (value, num) => olderThan(value, num) || `${num} évesnél idősebbnek kell lennie`,
    youngerThan: (value, num) => youngerThan(value, num) || `${num} évesnél fiatalabbnak kell lennie`,
    isFutureBy15Days: (value) => isFutureBy15Days(value) || ' A kockázatviselés kezdete nem lehet 15 napon belül.',
    firstOfMonth: (value) => firstOfMonth(value) || 'A kezdeti dátum csak a következő hónap elseje lehet.',
    superShop: (value) => lengthMay(value, 16) || 'A supershop kártya száma 16 hosszú szám!',
    isDate: (value, msg) => isDate(value, msg),
    isAdoszam: (value, message) => isAdoszam(value, message),
    isAdoazonositoJel: (value, message) => isAdoazonositoJel(value, message),
    isNyilatkozatElfogadva: (value, msg) => isNyilatkozatElfogadva(value, msg),
    isValidOkmany: (value, okm) => isValidOkmany(value, okm),
    isValidOkmanyErvenyesseg: (value) => isValidOkmanyErvenyesseg(value),
    isValidLakcimkartya: (value) => isValidLakcimkartya(value),
    isGeneralTextfieldCharacters: (value) => isGeneralTextfieldCharacters(value),
    isCegjegyzekszam: (value) => isCegjegyzekszam(value),
    isValidKotvenyszam: (value) => isValidKotvenyszam(value),
    isValidCsekksorszam: (value) => isValidCsekksorszam(value),
    isValidSuperShop: (value) => isValidSuperShop(value),
    isUnionPromociosKod: (value) => isUnionPromociosKod(value),
    isUnionSpecEngedmeny: (value) => isUnionSpecEngedmeny(value),
    isValidFunTartam: (value) => isValidFunTartam(value),
    isValidUnionGyerek: (value) => isValidUnionGyerek(value),
    isValidRisk_1560: (value) => isValidRisk1560(value),
    isValidRisk_1561: (value) => isValidRisk1561(value),
    isValidRisk_1562: (value) => isValidRisk1562(value),
    isValidRisk_1563: (value) => isValidRisk1563(value),
    isValidRisk_1565: (value) => isValidRisk1565(value),
    isValidRisk_1566: (value) => isValidRisk1566(value),
    isValidRisk_1567: (value) => isValidRisk1567(value),
    isValidRisk_1568: (value) => isValidRisk1568(value),
    isValidRisk_1569: (value) => isValidRisk1569(value),
    isValidRisk_1570: (value) => isValidRisk1570(value),
    isValidRisk_1571: (value) => isValidRisk1571(value),
    isValidBalesetKockkezdetDatum:
        (value) => isValidBalesetKockkezdetDatum(value) || 'Érvénytelen kockázatviselés kezdete',
    isVariableTypeAnObject: (value) => isVariableTypeAnObject(value),
    isVariableTypeAnArray: (value) => isVariableTypeAnArray(value),
    isKshSzam: (value) => isKshSzam(value) || 'KSH szám formátuma nem megfelelő!',
    gapTulajdonosiViszonyokv1:
        (tulajdoniViszony, tulajtipus) => gapTulajdonosiViszonyokv1(tulajdoniViszony, tulajtipus),
    gapTulajdonosiViszonyokv2:
        (tulajdoniViszony, tulajtipus) => gapTulajdonosiViszonyokv2(tulajdoniViszony, tulajtipus),

};

export function validate(validatorName, value, arg = null) {
    return rules[validatorName](value, arg);
}

/*
Ez azért kell, hogy a cégformánál csak akkor legyen kötelező ha cég van kiválasztva a v-show miatt
 */
